import { maxLength, required } from '../../utils/validation';

export const GroupValidations = {
  group: [required('models.group.name'), maxLength(24, 'models.group.name')]
};

class Serializer {
  normalize = data => {
    return {
      id: data.id,
      name: data.value
    };
  };

  serialize = group => {
    return {
      configValue: group.name,
      properties: {
        siteId: group.site
      }
    };
  };

  editSerialize = group => {
    return {
      name: group.name
    };
  };
}

export const GroupSerializer = new Serializer();



// WEBPACK FOOTER //
// ./src/models/group/index.js